// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
    width: 95% !important;
    margin: auto;
    height: 100%;
    bottom: 0;
    left: 10px;
    right: 10px;
}

.modal {
    position: fixed;
    display: inline-block !important;
    top: 0;
    bottom: 0;
    width: 100%;
    /* background: pink; */
    /*   height: 100%; */
    transition: opacity 0.25s ease;
    /*   z-index: 5; */
    background: rgba(0, 0, 0, 0.44) 0% 0% no-repeat padding-box;
}

.inner_content {
    cursor: pointer;
}

.close_btn {
    position: absolute;
    cursor: pointer;
}

.modal_content {
    position: fixed;
    background: white;
    bottom: 0;
    width: 100%;
    height: 80%;
    transform: translateY(0%);
    transition: all 0.5s ease;
    overflow-y: scroll;
    border-radius: 10px 10px 0px 0px;
    overflow-y: scroll;
}

.bottomsheet-header {
    align-items: center;
    justify-content: space-between;
}

.animation {
    transform: translateY(100%);
}

.bg_tranparent {
    background: transparent;
    height: 0;
}

.inner {
    padding: 20px;
}

@media only screen and (max-width: 600px) {
    .container {
        /* background: lightblue; */
        width: 100%;
    }

    .modal_content {
        width: 99.3%;
    }

    .modal {
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/style/bottomSheet.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,YAAY;IACZ,YAAY;IACZ,SAAS;IACT,UAAU;IACV,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gCAAgC;IAChC,MAAM;IACN,SAAS;IACT,WAAW;IACX,sBAAsB;IACtB,oBAAoB;IACpB,8BAA8B;IAC9B,kBAAkB;IAClB,2DAA2D;AAC/D;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,SAAS;IACT,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,2BAA2B;QAC3B,WAAW;IACf;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":[".container {\n    width: 95% !important;\n    margin: auto;\n    height: 100%;\n    bottom: 0;\n    left: 10px;\n    right: 10px;\n}\n\n.modal {\n    position: fixed;\n    display: inline-block !important;\n    top: 0;\n    bottom: 0;\n    width: 100%;\n    /* background: pink; */\n    /*   height: 100%; */\n    transition: opacity 0.25s ease;\n    /*   z-index: 5; */\n    background: rgba(0, 0, 0, 0.44) 0% 0% no-repeat padding-box;\n}\n\n.inner_content {\n    cursor: pointer;\n}\n\n.close_btn {\n    position: absolute;\n    cursor: pointer;\n}\n\n.modal_content {\n    position: fixed;\n    background: white;\n    bottom: 0;\n    width: 100%;\n    height: 80%;\n    transform: translateY(0%);\n    transition: all 0.5s ease;\n    overflow-y: scroll;\n    border-radius: 10px 10px 0px 0px;\n    overflow-y: scroll;\n}\n\n.bottomsheet-header {\n    align-items: center;\n    justify-content: space-between;\n}\n\n.animation {\n    transform: translateY(100%);\n}\n\n.bg_tranparent {\n    background: transparent;\n    height: 0;\n}\n\n.inner {\n    padding: 20px;\n}\n\n@media only screen and (max-width: 600px) {\n    .container {\n        /* background: lightblue; */\n        width: 100%;\n    }\n\n    .modal_content {\n        width: 99.3%;\n    }\n\n    .modal {\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
